export const SOURCE_BASE_PATH = (window as any).SOURCE_BASE_PATH || '/anov-prod/anov-3d/model'